import React, { useEffect, useState } from 'react';
import DetailItem from '@components/misc/detail/DetailItem';
import DetailSection from '@components/misc/detail/DetailSection';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { userDetailQueryAtom } from '@atom/globalQueryAtom';

interface IProfilePageData {
  email: string;
  mobile: string;
}

const AccountSettingPageContent = () => {
  const navigate = useNavigate();
  const getUserDetails = useAtomValue(userDetailQueryAtom);

  const [userDetail, setUserDetail] = useState<IProfilePageData>({
    email: '',
    mobile: '0',
  });

  useEffect(() => {
    if (getUserDetails.isSuccess) {
      setUserDetail({
        ...userDetail,
        email: getUserDetails?.data?.data.email,
        mobile: getUserDetails?.data?.data.phone,
      });
    }
  }, [getUserDetails.data]);

  function handleOnEditPassword() {
    navigate('/account-settings/change-password');
  }

  function handleOnEditAccount() {
    navigate('/account-settings/update-account');
  }

  const password = () => {
    const bulletCount: number[] = Array(10).fill(1);

    return (
      <div className={'flex align-middle pt-2'}>
        {bulletCount.map(item => {
          return (
            <div
              key={item}
              className={
                'w-2.5 h-2.5 mr-1 rounded-full inline-block bg-neutral-whiteboard'
              }
            />
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div
        className={
          'text-neutral-whiteboard text-lg mb-4 font-semibold max-lg:hidden'
        }
      >
        Profile
      </div>
      <DetailSection
        title={'Account'}
        onEdit={handleOnEditAccount}
        className={'mb-8'}
      >
        <DetailItem
          label={'Email'}
          value={userDetail.email}
          className={'mb-6'}
        />
        <DetailItem label={'Mobile'} value={userDetail.mobile} />
      </DetailSection>
      <DetailSection
        title={'Security'}
        onEdit={handleOnEditPassword}
        className={'mb-8'}
      >
        <DetailItem label={'Password'} value={password()} />
      </DetailSection>
    </>
  );
};

export default AccountSettingPageContent;
